/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_My_AccountInputs */

const en_dialog_delete_my_account = /** @type {(inputs: Dialog_Delete_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete my account`)
};

const es_dialog_delete_my_account = /** @type {(inputs: Dialog_Delete_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar mi cuenta`)
};

/**
* | output |
* | --- |
* | "Delete my account" |
*
* @param {Dialog_Delete_My_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_my_account = /** @type {((inputs?: Dialog_Delete_My_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_My_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_my_account(inputs)
	return en_dialog_delete_my_account(inputs)
});